// extracted by mini-css-extract-plugin
export default {"table_header":"SentimentTable_table_header__TKTop","sentiment_emoji":"SentimentTable_sentiment_emoji__+wrPJ"};